import * as React from 'react';
import * as style from './Explain.css';
import { trackScrollInformation } from '../Valuation/tracking';
import { isContainerVisible } from '../../utils/containerVisible';
import { IconCheck } from './icons';

const explainContent = [
  'Рыночную стоимость квартиры',
  'Максимальную и минимальную стоимость квартиры',
  'Разницу между ценой объявления и ценой фактической сделки',
  'Стоимость похожих квартир',
];

export function listItemRender(text: string, key: number) {
  return (
    <li key={key} className={style['list-item']}>
      <IconCheck />
      <span>{text}</span>
    </li>
  );
}

export class Explain extends React.Component {
  private container = React.createRef<HTMLDivElement>();

  public componentDidMount() {
    window.addEventListener('scroll', this.handleShowInformation);
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShowInformation);
  }

  private handleShowInformation = () => {
    if (isContainerVisible(this.container)) {
      trackScrollInformation('Learn');
      window.removeEventListener('scroll', this.handleShowInformation);
    }
  };

  public render() {
    return (
      <div className={style['explain']} ref={this.container}>
        <p className={style['learn_text']}>Отчет оценки включает</p>
        <ul className={style['list']}>{explainContent.map(listItemRender)}</ul>
      </div>
    );
  }
}
